import { pageSizes, pickerOptions, PAY_TYPE_OPTIONSS, drugType } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import { startDate } from '@/utils/filter';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';

export default {
  name: 'wait-fee',
  mixins: [pageSize],
  components: { HisAutocompleteSuggestions },
  data() {
    return {
      activeName: 'first',
      options: [],
      clinic: [],
      drugTypes: drugType,
      radio: '',
      pageSizes,
      pickerOptions,
      payTypes: PAY_TYPE_OPTIONSS,
      statTypes: [{
        value: 0,
        label: '全部',
      }, {
        value: 1,
        label: '收款',
      }, {
        value: 2,
        label: '退款',
      }, {
        value: 3,
        label: '还款',
      }],
      tableData: [],
      total: 0, // 总数据条数
      time: [],
      isMerge: 0,
      query: {
        hospitalIds: [6197], // 诊所id
        drugType: null,
        drugName: '', // 药品名称
        startDate: '',
        endDate: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
    };
  },
  methods: {
    // 药品名称检索
    querySearch(str, cb) {
      this.$api.drugControl.drugsNameList({ drugName: str }).then((res) => {
        if (Array.isArray(res.drugList) && res.drugList.length > 0) {
          cb(res.drugList);
        } else {
          cb([]);
        }
      });
    },
    // 选择药品名称
    selectHandle(e) {
      this.query.drugName = e.drugName;
      this.getTableData(1);
    },
    searchHandel(e) {
      this.query.drugName = e;
      this.getTableData(1);
    },
    // 获取列表信息
    getTableData(type) {
      if (type === 1) this.query.currentPage = 1;
      this.query.startDate = this.time ? this.time[0] : '';
      this.query.endDate = this.time ? this.time[1] : '';
      this.$api.chainManageStatistics.sales({
        ...this.query,
        isMerge: this.isMerge ? 1 : 0,
      }).then((res) => {
        console.log(res);
        this.tableData = res.data;
        this.total = res.totalSize;
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getTableData();
    },
  },
  mounted() {
    this.time = startDate(); // 设置默认日期
    this.getTableData();
  },
};
